
@if ((fetchingResults$ | async)!) {
  <p style="text-align:center">
    <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
  </p>
}

<div class="customer-buy">
  <!-- {{ data!.transactionStages }}

  <div [ngSwitch]="transactionStages[0]">
    <div *ngSwitchCase="TransactionStage.FAVORITE">Favoris </div>
    <div *ngSwitchCase="TransactionStage.ONGOING">🍌 Banana is yellow and sweet!</div>
    <div *ngSwitchCase="TransactionStage.COMPLETED">🍊 Orange is tangy and round!</div>
    <div *ngSwitchDefault>Please select a fruit</div>
  </div> -->
  <!--
  <div [ngSwitch]="transactionStages[0]">
    <h1 *ngSwitchCase="TransactionStage.FAVORITE">Mes favoris à acheter ({{ (myBuyCars$  | async)?.length}})</h1>
    <h1 *ngSwitchCase="TransactionStage.DRAFT">Mes brouillons achats ({{ (myBuyCars$  | async)?.length}})</h1>
    <h1 *ngSwitchCase="TransactionStage.ONGOING">Mes achats en cours ({{ (myBuyCars$  | async)?.length}})</h1>
    <h1 *ngSwitchCase="TransactionStage.COMPLETED">Mes achats complétés ({{ (myBuyCars$  | async)?.length}})</h1>
  </div> -->

  <h1>{{ data!.title }} ({{ (myBuyCars$  | async)?.length}})</h1>

  @if (!(fetchingResults$ | async)!) {
    <div class="favorites">
      <div class="buttons-section">
        <!--
        <button mat-button (click)="openCarEditDialog()" class="btn btn-default"><mat-icon>add</mat-icon>Ajouter une voiture</button>
        -->
      </div>
      @if (((myBuyCars$  | async) == undefined || (myBuyCars$  | async)!.length ==0)) {
        <h6>
          Aucun achat en cours
          <br />
          <br />
          <a [routerLink]="'/buy/search'"> <mat-icon>search</mat-icon> Rechercher </a>
        </h6>
      }
      @if (((myBuyCars$  | async) != undefined )) {
        <div class="cars-section">
          @for (car of (myBuyCars$  | async)!; track car; let i = $index) {
            <div id="{{car.offerId}}" class="car-section">
              <app-car-card-buyer
                [car]="car"
                [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
                [businessLine]="businessLine"
                [objectSource]="objectSource">
              </app-car-card-buyer>
            </div>
          }
        </div>
      }
    </div>
  }
  <!--
  <app-alerts
    [alerts]="(myProfile$ | async)!.alerts"
    >
  </app-alerts> -->
</div>

